/* eslint-disable */
// Auto-generated by scripts/fetch-widget-includes.mjs: the widget include library compiled into this build.
// Git-ignored. Without a fetch, `prebuild` writes it empty (no library, no startup set: every include from Core).
export const widgetIncludesLibrary = {
  "includes": {
    "aiwb-base": {
      "file": "aiwb-base.f42da4c52f1c98be.json",
      "sha256": "f42da4c52f1c98bee9d478dd7cf2a27fad48fabd3963d6f149db512f20f58620",
      "kind": "css"
    },
    "aiwb-calls": {
      "file": "aiwb-calls.34396345f5748de1.json",
      "sha256": "34396345f5748de16047dbc8cfa10d475c97a4d4ad365457dff7e832ce470789",
      "kind": "js"
    },
    "aiwb-data": {
      "file": "aiwb-data.11718bbc9123e56a.json",
      "sha256": "11718bbc9123e56a1d1d0dd8bdffd76232acf93e7527e2ddd0ecf4a8b421d4ae",
      "kind": "js"
    },
    "aiwb-escape": {
      "file": "aiwb-escape.a6b580480f2aa094.json",
      "sha256": "a6b580480f2aa094e8d30b981467a5b96be2f9baf60b02aa4341100cdb88117e",
      "kind": "js"
    },
    "aiwb-format": {
      "file": "aiwb-format.eae66999e2fcc1d5.json",
      "sha256": "eae66999e2fcc1d5368bd353766d6e4645c0fb0aa9343f71de1374777a5a61a2",
      "kind": "js"
    },
    "aiwb-layout": {
      "file": "aiwb-layout.5678eededc6930a4.json",
      "sha256": "5678eededc6930a451bf5762efcbc6838b8fa38013c387e83573f01b5bbbc0f1",
      "kind": "css"
    },
    "aiwb-lookups": {
      "file": "aiwb-lookups.429fb535e4a2b97c.json",
      "sha256": "429fb535e4a2b97c0c06caafc832d104d456577c1a09fae5d4d0f71ab6029124",
      "kind": "js"
    },
    "aiwb-reset": {
      "file": "aiwb-reset.1a1a536b1db97609.json",
      "sha256": "1a1a536b1db97609f500337e4055be799e82e1fe2d24b2cbe0e48b8e05e95749",
      "kind": "css"
    },
    "aiwb-standard": {
      "file": "aiwb-standard.05eb17670f0b9528.json",
      "sha256": "05eb17670f0b95288fc6fe283fdfaea442f25669ceb5bd19908e8d5d8ceaadff",
      "kind": "package",
      "includes": [
        "aiwb-base",
        "aiwb-escape",
        "aiwb-data",
        "aiwb-theme-defaults",
        "aiwb-format",
        "aiwb-utils",
        "aiwb-lookups",
        "aiwb-calls",
        "aiwb-states",
        "aiwb-status",
        "aiwb-reset",
        "aiwb-layout"
      ]
    },
    "aiwb-states": {
      "file": "aiwb-states.e33e95e084b0a7ac.json",
      "sha256": "e33e95e084b0a7aca1c8385388b67bf603c7d563e936248d6b2b56dc60693a16",
      "kind": "both"
    },
    "aiwb-status": {
      "file": "aiwb-status.378a456415891fdf.json",
      "sha256": "378a456415891fdf18bbb06d642b3f9635dbdcb5c007f7122707f2d68dce52d5",
      "kind": "both"
    },
    "aiwb-theme-defaults": {
      "file": "aiwb-theme-defaults.7e0816df4735776c.json",
      "sha256": "7e0816df4735776ca44fa442b46705ab015e79beea00062f1440ca018e0991d0",
      "kind": "css"
    },
    "aiwb-utils": {
      "file": "aiwb-utils.d5cd1111bf3eb2b5.json",
      "sha256": "d5cd1111bf3eb2b5d05741b55eb974eed949cdc4c18d537f72ad40f5bf617549",
      "kind": "js"
    }
  },
  "startup": [
    {
      "id": "aiwb-base",
      "file": "aiwb-base.f42da4c52f1c98be.json",
      "sha256": "f42da4c52f1c98bee9d478dd7cf2a27fad48fabd3963d6f149db512f20f58620"
    },
    {
      "id": "aiwb-escape",
      "file": "aiwb-escape.a6b580480f2aa094.json",
      "sha256": "a6b580480f2aa094e8d30b981467a5b96be2f9baf60b02aa4341100cdb88117e"
    },
    {
      "id": "aiwb-data",
      "file": "aiwb-data.11718bbc9123e56a.json",
      "sha256": "11718bbc9123e56a1d1d0dd8bdffd76232acf93e7527e2ddd0ecf4a8b421d4ae"
    }
  ]
};
